import React from 'react';
import styles from './BetTable3CardJ.module.css';

export default function BetTable3CardJ({ data = [], exposures = {}, remark = "" }) {
  // Extract YES and NO options from data
  const yesOption = data.find(item => item.nat?.toUpperCase() === "YES" || item.nat?.toUpperCase() === "Y") || {};
  const noOption = data.find(item => item.nat?.toUpperCase() === "NO" || item.nat?.toUpperCase() === "N") || {};

  // Check if option is suspended
  const isSuspended = (option) => {
    if (!option || !option.gstatus) return false;
    return option.gstatus.toUpperCase() === "SUSPENDED" || option.b === 0;
  };

  // Get exposure for YES/NO sections
  const getExposure = (selection) => {
    const exposureKeys = [
      selection,
      selection?.toLowerCase(),
      selection?.trim()
    ];

    let exposure = 0;
    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined) {
        exposure = exposures[key];
        break;
      }
    }
    return exposure;
  };

  // Format exposure value
  const formatExposure = (value) => {
    if (value === 0 || value === null || value === undefined) return "0";
    return value < 0 ? value.toFixed(0) : `+${value.toFixed(0)}`;
  };

  const yesBetValue = yesOption?.b || 0;
  const noBetValue = noOption?.b || 0;
  const yesExposure = getExposure(yesOption?.nat || "Yes");
  const noExposure = getExposure(noOption?.nat || "No");
  const yesSuspended = isSuspended(yesOption);
  const noSuspended = isSuspended(noOption);

  // Get remark text (split by | if it contains both messages)
  const getRemarkText = (index) => {
    if (remark && remark.includes('|')) {
      const remarks = remark.split('|');
      return remarks[index]?.trim() || (index === 0 
        ? "Select any 3 card and you will win if you will get at least 1 card from the 3 cards you have selected."
        : "Select any 3 card and you will win If you do not get any card from the 3 cards you have selected.");
    }
    return index === 0 
      ? "Select any 3 card and you will win if you will get at least 1 card from the 3 cards you have selected."
      : "Select any 3 card and you will win If you do not get any card from the 3 cards you have selected.";
  };

  // Generate card images (1-13 from andar_bahar folder)
  const cards = Array.from({ length: 13 }, (_, i) => i + 1);

  // Get card image URL
  const getCardImageUrl = (cardNum) => {
    return `https://d3kb8xz339pq18.cloudfront.net/v12/static/backend/images/andar_bahar/${cardNum}.jpg`;
  };

  return (
    <div className={`casino-detail casino-box ${styles.threecardjContainer}`}>
      <div className={styles.threecardjContainer}>
        {/* YES Box */}
        <div className={`${styles.threecardjBlBox} ${styles.back}`}>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#333'}} className={styles.threecardjTitle}>
            <b>Yes</b>
            <span className={`casino-book ml-2`} style={{ color: 'black' }}>
              {formatExposure(yesExposure)}
            </span>
          </div>
          <div className={`${styles.threecardjCards} ${yesSuspended ? styles.suspended : ''}`}>
            <div className={`${styles.threecardjOdds} text-center`}>
              <b>{yesSuspended ? "0" : yesBetValue || "0"}</b>
            </div>
            <div className={`casino-cards text-center mt-1`}>
              {cards.map((cardNum) => (
                <div key={`yes-${cardNum}`} className="casino-card-item">
                  <div className="card-image">
                    <img 
                      src={getCardImageUrl(cardNum)} 
                      className="andar-bahar-image"
                      alt={`Card ${cardNum}`}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className={`casino-min-max text-center`}>
              <span style={{fontSize: '14px', color: '#fff'}}>{getRemarkText(0)}</span>
            </div>
          </div>
        </div>

        {/* NO Box */}
        <div className={`${styles.threecardjBlBox} ${styles.lay}`}>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', background:'#333'}} className={styles.threecardjTitle}>
            <b>No</b>
            <span className={`casino-book ml-2`} style={{ color: 'black' }}>
              {formatExposure(noExposure)}
            </span>
          </div>
          <div className={`${styles.threecardjCards} ${noSuspended ? styles.suspended : ''}`}>
            <div className={`${styles.threecardjOdds} text-center`}>
              <b>{noSuspended ? "0" : noBetValue || "0"}</b>
            </div>
            <div className={`casino-cards text-center mt-1`}>
              {cards.map((cardNum) => (
                <div key={`no-${cardNum}`} className="casino-card-item">
                  <div className="card-image">
                    <img 
                      src={getCardImageUrl(cardNum)} 
                      className="andar-bahar-image"
                      alt={`Card ${cardNum}`}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className={`casino-min-max text-center`}>
              <span style={{fontSize: '14px', color: '#fff'}}>{getRemarkText(1)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

